// Every catalogue under ./locales/<language>/<namespace>.json, bundled. Adding
// a namespace is adding the two files; nothing here changes.
const modules = import.meta.glob("./locales/*/*.json", { eager: true, import: "default" });

export const resources = {};

for (const [file, messages] of Object.entries(modules)) {
	const [, language, namespace] = file.match(/\.\/locales\/([^/]+)\/([^/]+)\.json$/);
	resources[language] ??= {};
	resources[language][namespace] = messages;
}

export const namespaces = [...new Set(Object.values(resources).flatMap(Object.keys))];
